import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
// Demo: Calibração travada como "EM BREVE" (placeholder). Para destravar, voltar
// o component para o Index real (import Index from './Index.vue').
import EmBreve from 'dashboard/components/fandata/EmBreve.vue';
import Index from './Index.vue';
import BaseIndex from './BaseIndex.vue';
import BaseVersao from './BaseVersao.vue';
import BaseEditar from './BaseEditar.vue';
import BasePublicar from './BasePublicar.vue';
import BaseImportar from './BaseImportar.vue';
import BaseComportamento from './BaseComportamento.vue';
import BiraVoz from './BiraVoz.vue';
import Auditoria from './Auditoria.vue';

// Gating "EM BREVE" por ambiente (runtime): demo trava; dev/prod mostram a Calibração real.
const gated = ['true', true].includes(window.globalConfig?.FANDATA_DEMO_GATING);

// Central de Calibracao do Capitao (admin): playbook + tom/diretrizes.
export default {
  routes: [
    // A URL acompanha o nome que o clube usa: /settings/bira. O caminho antigo
    // (/settings/capitao) segue redirecionando, para não quebrar link salvo ou citado em
    // documento — o rename foi depois de a tela já estar em uso.
    {
      path: frontendURL('accounts/:accountId/settings/capitao'),
      redirect: to =>
        frontendURL(`accounts/${to.params.accountId}/settings/bira`),
    },
    {
      path: frontendURL('accounts/:accountId/settings/bira'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'capitao_calibracao',
          meta: {
            permissions: ['administrator'],
            emBreveTitulo: 'Bira · Calibração',
          },
          component: gated ? EmBreve : Index,
        },
        // Auditoria da configuração: quem mudou o quê. Fica sob Bira porque é aqui que se
        // muda o que ele diz, e é isso que o registro cobre.
        {
          path: 'auditoria',
          name: 'fandata_auditoria',
          meta: {
            permissions: ['administrator'],
            emBreveTitulo: 'Bira · Auditoria',
          },
          component: gated ? EmBreve : Auditoria,
        },
        // T-186, tela 3a: a Base de conhecimento abre na HISTÓRIA, não nas 334 respostas.
        {
          path: 'base',
          name: 'capitao_base',
          meta: {
            permissions: ['administrator'],
            larguraCheia: true,
            emBreveTitulo: 'Base de conhecimento',
          },
          component: gated ? EmBreve : BaseIndex,
        },
        // T-186, tela 4a: editar a base. É onde a pessoa passa o tempo dela.
        {
          path: 'base/editar',
          name: 'capitao_base_editar',
          meta: {
            permissions: ['administrator'],
            larguraCheia: true,
            emBreveTitulo: 'Base de conhecimento',
          },
          component: gated ? EmBreve : BaseEditar,
        },
        // T-186, tela 5a: publicar o rascunho, com o antes ao lado do depois e o teste na mesma
        // tela. Não é rota de detalhe do editar: publicar é uma decisão, e merece endereço.
        {
          path: 'base/publicar',
          name: 'capitao_base_publicar',
          meta: {
            permissions: ['administrator'],
            larguraCheia: true,
            emBreveTitulo: 'Base de conhecimento',
          },
          component: gated ? EmBreve : BasePublicar,
        },
        // T-186 Fase 4: subir a planilha com prévia. Endereço próprio porque importar é decisão,
        // como publicar, e não um detalhe da tela de edição.
        {
          path: 'base/importar',
          name: 'capitao_base_importar',
          meta: {
            permissions: ['administrator'],
            larguraCheia: true,
            emBreveTitulo: 'Base de conhecimento',
          },
          component: gated ? EmBreve : BaseImportar,
        },
        // T-186: publicar a voz tem endereço próprio. Ela publica sozinha desde a separação, e
        // deixar isso pendurado em `base/publicar` fazia a tela se apresentar como a da base.
        {
          path: 'voz/publicar',
          name: 'capitao_bira_voz_publicar',
          meta: {
            permissions: ['administrator'],
            larguraCheia: true,
            emBreveTitulo: 'Bira',
          },
          component: gated ? EmBreve : BasePublicar,
        },
        // T-186: uma voz do Bira, de um dia. `atual` abre a que está no ar.
        {
          path: 'voz/:id',
          name: 'capitao_bira_voz',
          meta: {
            permissions: ['administrator'],
            larguraCheia: true,
            emBreveTitulo: 'Bira',
          },
          component: gated ? EmBreve : BiraVoz,
        },
        // T-186: o comportamento (tom, diretrizes, transbordo) na MESMA porta da base. Ele
        // sempre viajou dentro da versão; o que faltava era uma tela que o tratasse assim.
        {
          path: 'base/comportamento',
          name: 'capitao_base_comportamento',
          meta: {
            permissions: ['administrator'],
            larguraCheia: true,
            emBreveTitulo: 'Base de conhecimento',
          },
          component: gated ? EmBreve : BaseComportamento,
        },
        // T-186, tela 3b: uma versão antiga em só leitura.
        {
          path: 'base/versao/:id',
          name: 'capitao_base_versao',
          meta: {
            permissions: ['administrator'],
            larguraCheia: true,
            emBreveTitulo: 'Base de conhecimento',
          },
          component: gated ? EmBreve : BaseVersao,
        },
      ],
    },
  ],
};
